module.exports = __webpack_public_path__ + "img/gold_apple.74d3c184.png";